import API from "../../services/api";
import {
    Bell,
    ShoppingBag,
    Truck,
    IndianRupee,
    Star,
    CheckCircle,
    AlertCircle,
    Clock,
    Trash2,
} from "lucide-react";

import {
    markAsRead,
    deleteNotification,
} from "../../services/notificationService";

import "./NotificationCard.css";

function NotificationCard({

    notification,

    onReload,

}) {

    const getIcon = () => {

        switch (notification.category) {

            case "order":
                return <ShoppingBag size={22} />;

            case "delivery":
                return <Truck size={22} />;

            case "payment":
                return <IndianRupee size={22} />;

            case "review":
                return <Star size={22} />;

            case "business":
                return <CheckCircle size={22} />;

            case "system":
                return <AlertCircle size={22} />;

            default:
                return <Bell size={22} />;

        }

    };

    const handleRead = async () => {

        if (notification.isRead) return;

        try {

            await markAsRead(notification._id);

            onReload();

        }

        catch (error) {

            console.error(error);

        }

    };

    const handleDelete = async () => {

        const confirmed = window.confirm(

            "Delete this notification?"

        );

        if (!confirmed) return;

        try {

            await deleteNotification(notification._id);

            onReload();

        }

        catch (error) {

            console.error(error);

        }

    };

   const handleAction = async (button) => {

    try {

        await API({

            url: button.api,

            method: button.method,

        });

        onReload();

    }

    catch (error) {

        console.error(error);

    }

};

    return (

        <div

            className={`notification-card ${

                notification.isRead

                    ? ""

                    : "unread"

            }`}

            onClick={handleRead}

        >

            <div className="notification-icon">

                {getIcon()}

            </div>

            <div className="notification-content">

                <div className="notification-top">

                    <h3>

                        {notification.title}

                    </h3>

                    <span>

                        <Clock size={14} />

                        {

                            new Date(

                                notification.createdAt

                            ).toLocaleString("en-IN")

                        }

                    </span>

                </div>

                <p>

                    {notification.message}

                </p>

                {

                    notification.data && (

                        <div className="notification-data">

                            {

                                notification.data.orderNumber && (

                                    <span>

                                        Order :

                                        {" "}

                                        {

                                            notification.data.orderNumber

                                        }

                                    </span>

                                )

                            }

                            {

                                notification.data.amount && (

                                    <span>

                                        ₹

                                        {

                                            Number(

                                                notification.data.amount

                                            ).toLocaleString(

                                                "en-IN"

                                            )

                                        }

                                    </span>

                                )

                            }

                        </div>

                    )

                }

                {

                    notification.actionRequired &&

                    notification.actionButtons?.length > 0 && (

                        <div className="notification-actions">

                            {

                                notification.actionButtons.map(

                                    (

                                        button,

                                        index

                                    ) => (

                                        <button

                                            key={index}

                                            onClick={(e) => {

                                                e.stopPropagation();

                                                handleAction(button);

                                            }}

                                            className="notification-action-btn"

                                        >

                                            {

                                                button.label

                                            }

                                        </button>

                                    )

                                )

                            }

                        </div>

                    )

                }

            </div>

            <button

                className="notification-delete"

                onClick={(e) => {

                    e.stopPropagation();

                    handleDelete();

                }}

            >

                <Trash2 size={18} />

            </button>

        </div>

    );

}

export default NotificationCard;